import { Map } from 'immutable';
import { createSelector } from 'reselect';

import {
  createHasActiveRequestSelectorFor,
  createFailedRequestSelectorFor,
} from 'redux-flight-control';

import {
  LOAD_SERVICE_PROVIDERS,
} from '../constants';

/* --------------------------- REQUEST SELECTORS --------------------------- */

/* --------------------------- LOAD_SERVICE_PROVIDERS --------------------------- */

export const loadServiceProvidersErrorSelector =
  createFailedRequestSelectorFor(LOAD_SERVICE_PROVIDERS);

export const loadServiceProvidersPendingSelector =
  createHasActiveRequestSelectorFor(LOAD_SERVICE_PROVIDERS);


/* --------------------------- SERVICE PROVIDER STORE SELECTORS --------------------------- */

export const serviceProviderStoreSelector = state => state.get('serviceProviders');

export const getServiceProviderById = (state, serviceProviderId) =>
  serviceProviderStoreSelector(state).getIn(['byId', serviceProviderId]) || Map();

export const makeGetServiceProviderById = () => createSelector(
  getServiceProviderById,
  serviceProvider => serviceProvider,
);

export const serviceProvidersSelector = createSelector(
  serviceProviderStoreSelector,
  serviceProvidersStore => serviceProvidersStore.get('responseIds').map(
    id => serviceProvidersStore.getIn(['byId', id]),
  ).toList(),
);



// WEBPACK FOOTER //
// ./redux/serviceProviders/selectors.js